var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    strokeMiterlimit: 10,
    "data-name": "Header - Opt 1 (Grey)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M26.56 25.94l-4.2-4.2a8.253 8.253 0 002.14-5.55c0-4.59-3.72-8.31-8.31-8.31s-8.31 3.72-8.31 8.31 3.72 8.31 8.31 8.31c2.14 0 4.08-.81 5.55-2.14l4.2 4.2.62-.62zm-10.37-2.32c-4.1 0-7.44-3.34-7.44-7.44s3.34-7.44 7.44-7.44 7.44 3.34 7.44 7.44-3.34 7.44-7.44 7.44z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.88 0 0 7.88 0 17.5S7.88 35 17.5 35 35 27.12 35 17.5 27.12 0 17.5 0h0z",
    fill: "#e1087e",
    stroke: "#e1087e",
    strokeWidth: 0.3
  }))));
}
export default SvgSearch;